import { render, staticRenderFns } from "./DebugModel.vue?vue&type=template&id=3c7d4fda&"
import script from "./DebugModel.ts?vue&type=script&lang=ts&"
export * from "./DebugModel.ts?vue&type=script&lang=ts&"
import style0 from "./DebugModel.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports